function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_227",
  "data-name": "Grupo 227",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_105",
  "data-name": "Trazado 105",
  d: "M1253.745,3276.505v38.179h-26.031a1.741,1.741,0,0,1-1.736-1.736v-27.767a8.68,8.68,0,0,1,8.677-8.677Z",
  transform: "translate(-1225.978 -3276.505)",
  fill: "#01033a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_106",
  "data-name": "Trazado 106",
  d: "M1316.982,3276.505h-59a8.681,8.681,0,0,1,8.677,8.677v57.269a17.354,17.354,0,0,0,17.354,17.354h41.65v-74.624A8.678,8.678,0,0,0,1316.982,3276.505Z",
  transform: "translate(-1249.301 -3276.505)",
  fill: "#064382"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_107",
  "data-name": "Trazado 107",
  d: "M1424.589,3519.705a19.192,19.192,0,0,1-19.09,17.354h-45.121a19.125,19.125,0,0,0,19.02-17.354Z",
  transform: "translate(-1323.934 -3453.759)",
  fill: "#01033a"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_95",
  "data-name": "Grupo 95",
  transform: "translate(24.294 8.677)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_108",
  "data-name": "Trazado 108",
  d: "M1324.822,3323.063l-3.515-1.172a3.307,3.307,0,0,1,1.044-6.444h.328a3.35,3.35,0,0,1,3.309,3.39c0,.027,0,.054,0,.081a1.666,1.666,0,0,0,1.677,1.655l.058,0a1.806,1.806,0,0,0,1.735-1.816,6.777,6.777,0,0,0-5.206-6.575v-1.938a1.736,1.736,0,0,0-3.471,0v1.938a6.766,6.766,0,0,0-.571,13.005l3.514,1.173a3.307,3.307,0,0,1-1.044,6.444h-.328a3.311,3.311,0,0,1-3.307-3.307v-.164a1.666,1.666,0,0,0-1.677-1.654h-.058a1.806,1.806,0,0,0-1.735,1.817,6.777,6.777,0,0,0,5.206,6.576v1.937a1.736,1.736,0,0,0,3.471,0v-1.937a6.767,6.767,0,0,0,.571-13.007Z",
  transform: "translate(-1315.572 -3308.505)",
  fill: "#e81687"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_109",
  "data-name": "Trazado 109",
  d: "M1410.274,3324.776h-22.56a1.735,1.735,0,1,1,0-3.471h22.56a1.735,1.735,0,0,1,0,3.471Z",
  transform: "translate(-1366.887 -3317.834)",
  fill: "#69a9f7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_110",
  "data-name": "Trazado 110",
  d: "M1410.274,3363.176h-22.56a1.735,1.735,0,1,1,0-3.471h22.56a1.735,1.735,0,0,1,0,3.471Z",
  transform: "translate(-1366.887 -3345.822)",
  fill: "#69a9f7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_111",
  "data-name": "Trazado 111",
  d: "M1410.274,3401.576h-22.56a1.735,1.735,0,1,1,0-3.471h22.56a1.735,1.735,0,0,1,0,3.471Z",
  transform: "translate(-1366.887 -3373.809)",
  fill: "#69a9f7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_112",
  "data-name": "Trazado 112",
  d: "M1358.963,3439.975h-41.65a1.735,1.735,0,1,1,0-3.47h41.65a1.735,1.735,0,1,1,0,3.47Z",
  transform: "translate(-1315.577 -3401.796)",
  fill: "#69a9f7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_113",
  "data-name": "Trazado 113",
  d: "M1358.963,3478.376h-41.65a1.735,1.735,0,0,1,0-3.471h41.65a1.735,1.735,0,1,1,0,3.471Z",
  transform: "translate(-1315.577 -3429.784)",
  fill: "#69a9f7"
})));

var SvgPaper = function SvgPaper(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100.654,
    height: 83.301,
    viewBox: "0 0 100.654 83.301",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaper, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paper.8f94a1bb.svg";
export { ForwardRef as ReactComponent };